import React from 'react';
import { LoadingMark } from '@/components/ui/LoadingMark';
import { useLoadingPreset } from '@/hooks/shared/useOrgPreset';

interface SimpleLoaderProps {
  message?: string;
}

/** Loader simples — mesmo visual base que `SplashScreen` / protótipo Vertto `Loading.jsx`. */
export const SimpleLoader: React.FC<SimpleLoaderProps> = ({
  message = 'Carregando...',
}) => {
  const brand = useLoadingPreset()?.loading;
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-8 bg-white px-6 font-sans antialiased text-gray-800 select-none"
      style={brand ? { backgroundColor: brand.background } : undefined}
    >
      <LoadingMark />

      <div className="flex flex-col items-center gap-3">
        <h1
          className="text-lg font-medium uppercase tracking-widest text-gray-500 md:text-xl"
          style={brand ? { color: brand.muted } : undefined}
        >
          Loading
        </h1>
        <div className="flex space-x-2" aria-hidden>
          <span className="loading-screen-dot" style={brand ? { backgroundColor: brand.accent } : undefined} />
          <span className="loading-screen-dot" style={brand ? { backgroundColor: brand.accent } : undefined} />
          <span className="loading-screen-dot" style={brand ? { backgroundColor: brand.accent } : undefined} />
        </div>
        <p className="text-center font-funnel text-sm text-gray-500" style={brand ? { color: brand.muted } : undefined}>
          {message}
        </p>
      </div>
    </div>
  );
};
